'use client';

import { cn } from '@/lib/ui/cn';
import * as React from 'react';

export interface MembershipTabItem {
  id: string;
  label?: string;
  content: React.ReactNode;
}

interface MembershipTabsProps {
  items: MembershipTabItem[];
}

export function MembershipTabs({ items }: MembershipTabsProps) {
  const [active, setActive] = React.useState(0);
  const uid = React.useId();
  const tabs = items.filter(item => item.label !== undefined);

  const tabId = (i: number) => `${uid}-tab-${i}`;
  const panelId = (i: number) => `${uid}-panel-${i}`;

  const bar = (
    <div
      role='tablist'
      aria-label='Membership plans'
      className='border-sh-dark-gray/15 col-span-full flex w-full justify-between border-b lg:hidden'
    >
      {tabs.map((tab, index) => (
        <button
          key={tab.id}
          type='button'
          role='tab'
          id={tabId(index)}
          aria-controls={panelId(index)}
          aria-selected={index === active}
          onClick={() => setActive(index)}
          className={cn(
            '-mb-px cursor-pointer border-b-4 pb-3 font-sans text-[18px] leading-[130%] tracking-normal whitespace-nowrap',
            index === active
              ? 'border-chip-teal-fill text-sh-dark-gray font-bold'
              : 'text-sh-brown border-transparent font-normal'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <>
      {bar}
      {items.map(item => {
        const index = tabs.indexOf(item);

        if (index === -1) {
          return <React.Fragment key={item.id}>{item.content}</React.Fragment>;
        }

        return (
          <div
            key={item.id}
            role='tabpanel'
            id={panelId(index)}
            aria-labelledby={tabId(index)}
            className={cn(
              index === active ? 'w-full' : 'hidden',
              'lg:contents'
            )}
          >
            {item.content}
          </div>
        );
      })}
    </>
  );
}
